<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content [showDefaultFormFooter]="true" [contentClasses]="['floatingLabelContainer']">
        <p-floatlabel variant="on">
            <p-select
                inputId="type"
                [autoDisplayFirst]="false"
                [options]="userTypeOptions"
                formControlName="type"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
            ></p-select>
            <label for="type">Type</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <input id="firstname" type="text" pInputText formControlName="firstname" />
            <label for="firstname">{{
                !UserOO8CPMApiModelUtils.is_user_type_a_machine_to_machine(form.controls['type'].value)
                    ? 'Firstname'
                    : 'Machine name'
            }}</label>
        </p-floatlabel>

        @if (!UserOO8CPMApiModelUtils.is_user_type_a_machine_to_machine(form.controls['type'].value)) {
            <p-floatlabel variant="on">
                <input id="lastname" pInputText formControlName="lastname" />
                <label for="lastname">Lastname</label>
            </p-floatlabel>

            <p-floatlabel variant="on">
                <input id="email" pInputText formControlName="email" />
                <label for="email">Email</label>
            </p-floatlabel>

            @if (isCreationMode) {
                <p-floatlabel variant="on">
                    <input id="password" pInputText type="password" formControlName="password" />
                    <label for="password">Temporary password</label>
                </p-floatlabel>
            }
        }

        @if (UserOO8CPMApiModelUtils.is_user_type_a_machine_to_machine(form.controls['type'].value)) {
            <p-floatlabel variant="on">
                <p-datepicker
                    id="expiration_date"
                    formControlName="expiration_date"
                    [showTime]="true"
                    [showIcon]="true"
                    [readonlyInput]="true"
                    [fluid]="false"
                    appendTo="body"
                ></p-datepicker>
                <label for="expiration_date">Access expired at</label>
            </p-floatlabel>
        }

        @if (!UserOO8CPMApiModelUtils.has_user_type_super_admin_privileges(form.controls['type'].value)) {
            <p-floatlabel variant="on">
                <p-select
                    inputId="global_user_role_uuid"
                    [autoDisplayFirst]="false"
                    [options]="globalUserRoles"
                    [showClear]="true"
                    formControlName="global_user_role_uuid"
                    optionLabel="name"
                    optionValue="uuid"
                    appendTo="body"
                ></p-select>
                <label for="global_user_role_uuid">Global User Role</label>
            </p-floatlabel>
        }
    </app-ibase-cru-modal-content>
</form>
